import React,{useState,useEffect,useRef, useContext} from 'react';
import {Container,Row,Col} from 'react-bootstrap';
import { TablaOficinas } from './Components';
import { SelectAgente, SelectTypeAgente } from '../../Components/SelectGroup/SelectGroup';
import '../../pages/Dashboard/dashboard.css';
import { AuthContext } from '../../auth/AuthContext';
import {
  BrowserRouter as Router,
  Redirect,
  useHistory,
} from "react-router-dom";

export const Oficinas = ({state,updateState}) => {

  let history = useHistory();
  
  const ref = useRef(null);
  const {openMenu} = state;
  const [selectedAgentes, setSelectedAgentes] = useState('0');
  const [selectedTipos, setSelectedTipos] = useState('0');
  const [isSticky, setSticky] = useState(false);
  const [loadDataOficinas,setLoadDataOficinas] = useState(false);

  const handleScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled>0 ? setSticky(true) : setSticky(false) 
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [])

  const handleChangeAgentes = (e) => {
    setLoadDataOficinas(true); 
    setSelectedAgentes(e.target.value);
  }

  const handleChangeAgentesTipos = (e) => {
    setLoadDataOficinas(true); 
    setSelectedTipos(e.target.value);
  }

  const { usuario } = useContext(AuthContext);
  const { nombre,tipo } = usuario;

  if(tipo=='3' || tipo=='2'){
    history.replace("/agentes");
    return false;
  }

  return (
    <React.Fragment>
      <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
        <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
          <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{borderBottom:'1px solid #ccc'}}>
            <Row>
              <Col className="mb-2" xs={12} md={3}>
                <h1 className="ws_title_header">Oficinas</h1>
              </Col>
              <Col className="mb-2" xs={12} md={9}>
                <Row>
                  {/* <SelectAgente 
                  className="ws_select_opt" 
                  value={selectedAgentes} 
                  onChange={ handleChangeAgentes } 
                  /> */}
                  <SelectTypeAgente 
                  className="ws_select_opt"
                  value={selectedTipos}
                  onChange={ handleChangeAgentesTipos }
                  />
                </Row>
              </Col>
            </Row>
          </Container>
          <Container fluid className="mt-5">
            <Row>
              <TablaOficinas 
              state={state} 
              updateState={updateState} 
              loadDataOficinas={loadDataOficinas} 
              setLoadDataOficinas={setLoadDataOficinas} 
              dataSelect={{selectedAgentes,selectedTipos}}
              />
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}
